const SikhyarthiContent = [
  {
    description: (
      <>
        <p>
          This is an initiative to serve descriptive tutorial videos and study materials to the primary students with odia background.  The site focuses on organizing tutorial videos that include subjects from “New Life Education Trust” textbooks as well as other important subjects. In recent times as the importance of remote learning has been increasing, we should also take steps to produce better tutorial videos in conversational odia so that every average Odia student could learn important lessons without any language barrier. We aspire, everyone with a will to provide or acquire knowledge in our beloved mother language to join us kindly or leave any suggestion in the lower suggestions section. Thank you for your time!  
        </p>
        <br />
        <p>
          The document of the project is available in the following link.
        </p>
      </>
    ),
    badge: "About",
    image:
      "https://try-er.github.io/debasish/assets/images/project_images/sikharythi_page.png",
  },
  {
    description: (
      <>
        <p>
          More than 100 videos are uploaded to YouTube and embedded to a WIX website to serve to students.
          The domain name is currently down but you can see the page with the following link
        </p>
      </>
    ),
    badge: "Deployment",
    links: [
      {
        image: "https://static-00.iconduck.com/assets.00/wix-icon-2048x2048-petxyljo.png",
        url: "https://avyarth00.wixsite.com/thesikhyarthi",
        text: "Sikhyarthi",
      }
    ]
  },
  {
    description: (
      <>
        <p>
          The youtube channel serviing these videos can be found in the following link. 
        </p>
      </>
    ),
    links: [
      {
        image: "https://cdn-icons-png.flaticon.com/256/1384/1384060.png",
        url: "https://www.youtube.com/@thesikhyarthi965",
        text: "Sikhyarthi",
      }
    ]
  }
];

export { SikhyarthiContent };